export default "__VITE_ASSET__CZsRVaQd__"